
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profil/[id]/perangkat-ajar/[category]",
      function () {
        return require("private-next-pages/profil/[id]/perangkat-ajar/[category].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profil/[id]/perangkat-ajar/[category]"])
      });
    }
  